import FormTake from './form-take'
export default FormTake;